import type {IMySongsPageStore} from "./mySongsPage.types";

export const initialMySongsPageState: IMySongsPageStore = {
  // we may want to load persisted filter data here
};
